import { Button, Flex, Text } from "@gravity-ui/uikit";
import cn from "classnames";
import { Link, Outlet } from "react-router-dom";
import { T } from "src/i18n";
import { RoutesPaths } from "src/routes/RoutesPaths";
import { Footer } from "src/widgets/Footer/Footer";
import { Header } from "src/widgets/Header/Header";

import { KnowledgeDropdownToc, KnowledgeSidebar } from "./components";
import { routePath } from "./constants";
import styles from "./KnowledgeBaseLayout.module.scss";
import { KnowledgeBaseOutletContext } from "./types";
import { useKnowledgeBaseLayout } from "./useKnowledgeBaseLayout";

const KNOWLEDGE_BASE_PATH = routePath.base;

export const KnowledgeBaseLayout = () => {
  const { tree, itemsToc, activeId, setActiveId, activeSectionSlug } =
    useKnowledgeBaseLayout(KNOWLEDGE_BASE_PATH);

  if (!tree) {
    return null;
  }

  const outletContext: KnowledgeBaseOutletContext = {
    basePath: KNOWLEDGE_BASE_PATH,
    route: "base",
    tree,
    itemsToc,
    activeId,
    onActiveChange: setActiveId,
  };

  return (
    <Flex direction={"column"} alignItems={"center"} className={styles.page}>
      <Header
        actionsMobile={
          <div>
            <KnowledgeSidebar
              basePath={KNOWLEDGE_BASE_PATH}
              tree={tree}
              size="xl"
              activeSection={activeSectionSlug}
            />
          </div>
        }
        actions={
          <>
            {itemsToc.length > 0 && (
              <KnowledgeDropdownToc
                activeId={activeId}
                items={itemsToc}
                size="l"
              />
            )}
            <Link to={RoutesPaths.LK.BASE_PATH}>
              <Button size="xl" view="action" className={styles.button}>
                <Text variant="subheader-1">
                  <T
                    keyName="landing_page.header.login_button"
                    defaultValue="Начать работать"
                  />
                </Text>
              </Button>
            </Link>
          </>
        }
      />

      <div className={styles.contentDefault}>
        <div className={cn(styles.layoutFrame, styles.layoutFrameBase)}>
          <div className={styles.layoutMenu}>
            <div className={styles.layoutMenuPosition}>
              <KnowledgeSidebar
                basePath={KNOWLEDGE_BASE_PATH}
                tree={tree}
                size="xl"
                activeSection={activeSectionSlug}
              />
            </div>
          </div>

          <div className={styles.frame}>
            <Outlet context={outletContext} />
          </div>
        </div>
      </div>

      <Footer />
    </Flex>
  );
};
